module.exports = __webpack_public_path__ + "img/social-info2.b2573da2.png";